import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import {connect} from 'react-redux';

import './events.css';
import AppGrid from '../../../Helper/AppWrapper/appWrapper';
import Block from './eventBlock';
import Loader from '../../../Helper/loader/loader';;

const styles={

};

class EventsAppView extends React.Component{


    render() {
        const {events, user, eventAppScroll} = this.props;
        let show = (user.results.BusinessUser.IsFirstVisit && JSON.parse(user.results.BusinessUser.IsFirstVisit)['My Local Events']);
        return (
            <AppGrid header={'Live Preview'} tab={4}
                     content={
                         <div className={(show) ? 'event-list' : 'event-list-small'} onScroll={e => eventAppScroll(e, events.TotalCounts)}>
                             {
                                 events.EventDetailData && events.EventDetailData.map((event, index) => {
                                     return (
                                         <Block event={event} user={user} key={index}/>
                                     )
                                 })
                             }
                             {
                                 !events.eventDetailReceived ? <div className='text-center'><Loader/></div>
                                     :
                                     (!events.EventDetailData.length > 0) &&
                                     <div className='no-data-div'>@{user.results.AppUser.UserName}<br/> Doesn’t have any
                                         events to show.</div>
                             }
                         </div>
                     }/>
        )
    }
}
const mapStateToProps = state => {
    return {
        events: state.events,
    }
};

export default connect(mapStateToProps, null)(withStyles(styles)(EventsAppView));